import { hasWindow } from '@/utils/dom';

type BreakpointsType = {
	xs: string;
	sm: string;
	md: string;
	lg: string;
	xl: string;
	'2xl': string;
	'3xl': string;
	'4xl': string;
};

const breakpoints = () => {
	if (hasWindow()) {
		const styles = window?.getComputedStyle(document.documentElement);
		const breakpoints: BreakpointsType = {
			xs: styles.getPropertyValue('--container-xs'),
			sm: styles.getPropertyValue('--container-sm'),
			md: styles.getPropertyValue('--container-md'),
			lg: styles.getPropertyValue('--container-lg'),
			xl: styles.getPropertyValue('--breakpoint-xl'),
			'2xl': styles.getPropertyValue('--breakpoint-2xl'),
			'3xl': styles.getPropertyValue('--breakpoint-3xl'),
			'4xl': styles.getPropertyValue('--breakpoint-4xl'),
		};
		return breakpoints;
	}

	return {} as BreakpointsType;
};

export function getMediaQuery(breakpoint: keyof BreakpointsType): string {
	return `(min-width: ${breakpoints()[breakpoint]})`;
}
